<div class="mx-auto w-full h-full justify-center space-y-6 sm:w-96">
  <div class="space-y-2 text-center">
    <h1 class="text-2xl font-semibold tracking-tight">
      Verifica la tua email
    </h1>
    <p class="text-muted-foreground text-sm">
      Inserisci il codice di verifica che ti abbiamo inviato
    </p>
  </div>
  <div class="grid gap-6">
    <form [formGroup]="form" (ngSubmit)="confirmSignUp()">
      <div class="space-y-2">
        <label hlmLabel> Codice di verifica </label>
        <brn-input-otp
          hlm
          [maxLength]="6"
          inputClass="disabled:cursor-not-allowed"
          formControlName="code"
          [transformPaste]="transformPaste"
          (completed)="confirmSignUp()"
          class="w-full flex justify-center"
        >
          <div hlmInputOtpGroup>
            <hlm-input-otp-slot [index]="0" />
            <hlm-input-otp-slot [index]="1" />
            <hlm-input-otp-slot [index]="2" />
            <hlm-input-otp-slot [index]="3" />
            <hlm-input-otp-slot [index]="4" />
            <hlm-input-otp-slot [index]="5" />
          </div>
        </brn-input-otp>
        @if (hasError()) {
          <p class="text-destructive text-sm mt-2">
            {{ errorMessage() }}
          </p>
        }
      </div>

      <button hlmBtn [disabled]="isLoading()" class="mt-4 w-full">
        @if (isLoading()) {
          <hlm-spinner class="mr-2" />
        }
        Verifica e continua
      </button>

      <button
        hlmBtn
        variant="link"
        [disabled]="isLoading()"
        class="mt-4 w-full"
        (click)="onResendCodeClick()"
        type="button"
      >
        Non hai ricevuto il codice? Invia nuovamente
      </button>

      <button
        hlmBtn
        variant="link"
        class="mt-4 w-full"
        [disabled]="isLoading()"
        (click)="onSignInClick()"
        type="button"
      >
        Torna al login
      </button>
    </form>
  </div>
</div>
